export const version = '1.8.4';
//# sourceMappingURL=version.js.map